import React, { useContext } from "react";
import { SiteColorContext } from "../Store";
import TwinRoutes from "../../TwinRoutes";

const lightStyle = {
    width: "100%",
    textAlign: "center",
    background: "#F0F4F8",
    color: "#1A2A3A",
    overflowX: "hidden",
    overflowY: "auto",
};

const darkStyle = {
    width: "100%",
    textAlign: "center",
    background: "#0D1B2A",
    color: "#E3F2FD",
    overflowX: "hidden",
    overflowY: "auto",
};

const MainView = (props) => {
    const [SiteColor] = useContext(SiteColorContext);

    return (
        <div style={SiteColor ? lightStyle : darkStyle}>
            <TwinRoutes {...props} />
        </div>
    );
};

export default MainView;
